import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { useSelector } from 'react-redux';

import { useIsAspPaymentGridRedesignActive } from './useIsAspPaymentGridRedesignActive';

export const useIsExplicitLenderProgramGridActive = (): boolean => {
    const isToggleEnabled = useSelector(featureToggleSelectors.isExplicitLenderP1Enabled);
    const isRedesignActive = useIsAspPaymentGridRedesignActive();

    return isToggleEnabled && isRedesignActive;
};
